var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 58,
    height: 58,
    rx: 16,
    fill: "#FDDB44",
    stroke: "#184985",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 14.2 L38.6 14.2 L36.9 19.5 L40.3 21.5 L44.1 17.4 L50.7 28.8 L45.3 30.0 L45.3 34.0 L50.7 35.2 L44.1 46.6 L40.3 42.5 L36.9 44.5 L38.6 49.8 L25.4 49.8 L27.1 44.5 L23.7 42.5 L19.9 46.6 L13.3 35.2 L18.7 34.0 L18.7 30.0 L13.3 28.8 L19.9 17.4 L23.7 21.5 L27.1 19.5 Z",
    fill: "#184985",
    stroke: "#184985",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 6.2,
    fill: "#FDDB44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndy);
export default __webpack_public_path__ + "static/media/indy.cd0551012754ae973fcd9151d3d292dc.svg";
export { ForwardRef as ReactComponent };